import { render, staticRenderFns } from "./TextDisplay1.vue?vue&type=template&id=72dc785c&scoped=true&"
import script from "./TextDisplay1.vue?vue&type=script&lang=js&"
export * from "./TextDisplay1.vue?vue&type=script&lang=js&"
import style0 from "./TextDisplay1.vue?vue&type=style&index=0&id=72dc785c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc785c",
  null
  
)

export default component.exports